<template>
  <div id="contenedor-listado-sub-tipos-obra-desktop">
    <v-data-table :headers="headers" :items="listadoSubTiposObras" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :subTipoObra="item"></opciones>
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <v-avatar
        size="35"
        :color="item.color">
        </v-avatar>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoSubTiposObraDesktop',
  props: {
    listadoSubTiposObras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        { text: '', width: 60, value: 'color' },
        {
          text: 'Descripción',
          align: 'start',
          value: 'descripcion',
        },
        { text: 'Fecha de Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
